import { KeyValue } from '@mews/enums';
import { Input } from '@mews-commander/legacy-form';
import TwoLineTitle from '../../../legacy/React/Components/Common/TwoLineTitle';
import ThreadSubject from './ThreadSubject';

interface Props {
    subjectDraft: string;
    subjectDraftUpdated: $TSFixMeFunction;
    isEditMode: boolean;
    onSave: $TSFixMeFunction;
}

const SubjectFieldComponent = (props: Props) => {
    // @ts-expect-error $TSFixMeError: Property 'thread' does not exist on type 'Props'.
    const { isEditMode, subjectDraft, onSave, subjectDraftUpdated, thread } = props;
    const { subject, creatorProfileId } = thread;

    const handleTextChange = (_: $TSFixMe, val: $TSFixMe) => subjectDraftUpdated(val);

    const handleKeyDown = (event: $TSFixMe) => {
        if (event.key === KeyValue.Enter) {
            event.preventDefault();
            onSave();
        }
    };

    return isEditMode ? (
        // @ts-expect-error $TSFixMeError: Type '{ value: string; onKeyDown: (event: any) => void; onChange: (_: any, val: any) => any; }' is not assignable to typ...
        <Input value={subjectDraft} onKeyDown={handleKeyDown} onChange={handleTextChange} />
    ) : (
        <TwoLineTitle>
            {creatorProfileId ? <ThreadSubject subject={subject} profileId={creatorProfileId} /> : subject}
        </TwoLineTitle>
    );
};

export default SubjectFieldComponent;
